// Store reducers
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
  appReducer: {
    isLoading: boolean;
    showModal: { show: boolean; noticeId: string };
    curLanguage: string;
  };
}

// Definir interfaces para las acciones
interface LoadingAction {
  type: 'ACTION_LOADING';
  payload: boolean;
}

interface ShowModalAction {
  type: 'SHOW_MODAL';
  payload: { show: boolean; noticeId: string };
}

interface SetLanguageAction {
  type: 'SET_LANGUAGE';
  payload: string;
}

type AppActions = LoadingAction | ShowModalAction | SetLanguageAction;

export const reducers: ActionReducerMap<AppState> = {
  appReducer: (state = {
    isLoading: false,
    showModal: { show: false, noticeId: '' },
    curLanguage: 'es'
  }, action: AppActions) => {
    switch (action.type) {
      case 'ACTION_LOADING':
        return { ...state, isLoading: action.payload };
      case 'SHOW_MODAL':
        return {
          ...state,
          showModal: {
            ...state.showModal,
            ...action.payload
          }
        };
      case 'SET_LANGUAGE':
        return { ...state, curLanguage: action.payload };
      default:
        return state;
    }
  }
}; 